import { createReducer } from '@reduxjs/toolkit'

import { arrayToObject } from 'utils/functions'
import { IRealEstate } from 'types/GlobalRealEstate'

import * as actions from '../../actions/RealEstates/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export type TRealEstateBody = {
  [key: string]: IRealEstate
}

export interface IRealEstateReducerType {
  data: TRealEstateBody
  fetched: boolean
}

// Initial state
const INITIAL_STATE: IRealEstateReducerType = {
  data: {},
  fetched: false
}

// Reducer
const realEstateReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = arrayToObject<IRealEstate>(action.payload.data)
      state.fetched = true
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})

export default realEstateReducer
